import ColorPicker, { ColorPickerSquare } from "components/ColorPicker";
import { DetailSectionTemplate } from "components/MainSectionTemplate/DetailSectionTemplate";
import { RenderEditOptions } from "components/MainSectionTemplate/types";
import RequiredTextInput from "components/ValidatedFields/RequiredTextInput";
import React, { useState } from "react";

interface TagDetailSectionProps {
  tag: server.dto.TagSmall
}

export const TagDetailSection = (props: TagDetailSectionProps) => {
  const [tag, setTag] = useState<server.dto.TagSmall>(props.tag);

  const onValueChanged = (key: string, value: any) => {
    if (key === "title") {
      setTag({ ...tag, title: value });
    } else if (key === "color") {
      setTag({ ...tag, hexColor: value });
    } else if (key === "code") {
      setTag({ ...tag, code: value });
    }
  }

  return <DetailSectionTemplate
    isInPageEditable
    onValueChanged={onValueChanged}
    sections={[{
      type: "regular",
      key: "tag",
      title: RESX.Tag.resxTag,
      fields: [{
        key: "title",
        label: RESX.GeneralLabels.Title,
        render: () => <div>{tag.title}</div>,
        inPageEdit: {
          render: ({ value, onChange, submit, cancel }: RenderEditOptions<string>) => <RequiredTextInput
            validatorKey="title"
            focusOnMount
            maxLength={serverReference.constants.tag.maxTitleLength}
            value={value}
            onChange={(title) => { onChange(title); }}
            onEnter={() => submit()}
            onEsc={() => cancel()}
          />,
          fullWidth: true,
          type: "confirmOrCancelButton",
          initialValue: tag.title,
          submitChange: (title: string) => window.CoreApi.Tag.Update({
            title,
            hexColor: tag.hexColor,
            code: tag.code,
            tagId: tag.tagId,
          }),
        },
      }, {
        key: "code",
        label: RESX.Tag.DisplayInList,
        render: () => <div>{tag.code}</div>,
        inPageEdit: {
          render: ({ value, onChange, submit, cancel }: RenderEditOptions<string>) => <RequiredTextInput
            validatorKey="code"
            focusOnMount
            maxLength={serverReference.constants.tag.maxCodeLength}
            value={value}
            onChange={(code) => { onChange(code); }}
            onEnter={() => submit()}
            onEsc={() => cancel()}
          />,
          fullWidth: true,
          type: "confirmOrCancelButton",
          initialValue: tag.code,
          submitChange: (code: string) => window.CoreApi.Tag.Update({
            title: tag.title,
            hexColor: tag.hexColor,
            code,
            tagId: tag.tagId,
          }),
        },
      }, {
        key: "color",
        label: RESX.GeneralLabels.resxColor,
        render: () => <ColorPickerSquare value={tag.hexColor} />,
        inPageEdit: {
          render: ({ value, onChange, submit }: RenderEditOptions<string>) => <div className="main-section-template-fields-padding">
            <ColorPicker
              startOpen
              onClose={() => submit()}
              value={value}
              onChange={(hexColor) => { onChange(hexColor); }}
            />
          </div>,
          fullWidth: true,
          disableClickOutside: true,
          type: "custom",
          initialValue: tag.hexColor,
          submitChange: (hexColor: string) => window.CoreApi.Tag.Update({
            title: tag.title,
            code: tag.code,
            hexColor,
            tagId: tag.tagId,
          }),
        }
      }, {
        key: "tagId",
        label: "SystemOne ID",
        render: () => <div>{tag.tagId}</div>,
      }],
    }]}
  />
}